// noinspection JSUnusedGlobalSymbols

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string };
};

export type AddToBagInput = {
  productId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type AddToWishlistInput = {
  productId: Scalars['String']['input'];
  wishlistId?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  landmark?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  accessToken: Scalars['String']['output'];
};

export type Bag = {
  __typename?: 'Bag';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<BagItem>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BagItem = {
  __typename?: 'BagItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  product: Product;
  quantity: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BagItemQuantityInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type Category = {
  __typename?: 'Category';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  products?: Maybe<Array<Product>>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type CheckoutLineItem = {
  __typename?: 'CheckoutLineItem';
  lineSavings: Scalars['Float']['output'];
  lineTotal: Scalars['Float']['output'];
  originalUnitPrice: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productSlug: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type CheckoutQuote = {
  __typename?: 'CheckoutQuote';
  billingAddress?: Maybe<Address>;
  couponCode?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  discountTotal: Scalars['Float']['output'];
  items: Array<CheckoutLineItem>;
  shippingAddress?: Maybe<Address>;
  shippingTotal: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  taxTotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type CompleteCheckoutInput = {
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  paymentApproved: Scalars['Boolean']['input'];
  shippingAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteCheckoutResult = {
  __typename?: 'CompleteCheckoutResult';
  message?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  quote: CheckoutQuote;
  success: Scalars['Boolean']['output'];
};

export type Coupon = {
  __typename?: 'Coupon';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountType: CouponDiscountType;
  discountValue: Scalars['Float']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  maximumDiscountAmount?: Maybe<Scalars['Float']['output']>;
  minimumCartValue?: Maybe<Scalars['Float']['output']>;
  perUserLimit?: Maybe<Scalars['Float']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usageLimit?: Maybe<Scalars['Float']['output']>;
};

export enum CouponDiscountType {
  Fixed = 'FIXED',
  Percent = 'PERCENT',
}

export type CreateWishlistInput = {
  name: Scalars['String']['input'];
};

export type GuestQuoteCheckoutInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  items: Array<GuestQuoteLineItemInput>;
};

export type GuestQuoteLineItemInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type HomepageContent = {
  __typename?: 'HomepageContent';
  articleCopy: Scalars['String']['output'];
  articleLabel: Scalars['String']['output'];
  articleTitle: Scalars['String']['output'];
  collectionCopy: Scalars['String']['output'];
  collectionLabel: Scalars['String']['output'];
  collectionTitle: Scalars['String']['output'];
  newArrivalCopy: Scalars['String']['output'];
  newArrivalLabel: Scalars['String']['output'];
  newArrivalTitle: Scalars['String']['output'];
  specialOfferCopy: Scalars['String']['output'];
  specialOfferLabel: Scalars['String']['output'];
  specialOfferTitle: Scalars['String']['output'];
};

export type LoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addToBag: Bag;
  addToWishlist: Wishlist;
  adjustProductStock: Product;
  changePassword: Scalars['Boolean']['output'];
  clearBag: Bag;
  completeCheckout: CompleteCheckoutResult;
  createAddress: Address;
  createCategory: Category;
  createProduct: Product;
  createWishlist: Wishlist;
  deleteAddress: Scalars['Boolean']['output'];
  deleteCategory: Scalars['Boolean']['output'];
  deleteProduct: Scalars['Boolean']['output'];
  deleteWishlist: Scalars['Boolean']['output'];
  guestQuoteCheckout: CheckoutQuote;
  login: AuthPayload;
  logout: Scalars['Boolean']['output'];
  quoteCheckout: CheckoutQuote;
  register: AuthPayload;
  registerPushSubscription: Scalars['Boolean']['output'];
  removeFromBag: Bag;
  removeFromWishlist: Wishlist;
  renameWishlist: Wishlist;
  setBagItemQuantity: Bag;
  setDefaultBillingAddress: UserPreference;
  setDefaultShippingAddress: UserPreference;
  setDefaultWishlist: Wishlist;
  startRazorpayCheckout: RazorpayCheckoutSession;
  updateAddress: Address;
  updateCategory: Category;
  updateNotificationPreference: NotificationPreference;
  updateOrderStatus: Order;
  updateProduct: Product;
  updateUserPreference: UserPreference;
  verifyRazorpayPayment: CompleteCheckoutResult;
};

export type MutationAddToBagArgs = {
  input: AddToBagInput;
};

export type MutationAddToWishlistArgs = {
  input: AddToWishlistInput;
};

export type MutationAdjustProductStockArgs = {
  slug: Scalars['String']['input'];
  stockQuantity: Scalars['Float']['input'];
};

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};

export type MutationCompleteCheckoutArgs = {
  input: CompleteCheckoutInput;
};

export type MutationCreateAddressArgs = {
  input: AddressInput;
};

export type MutationCreateCategoryArgs = {
  input: CategoryInput;
};

export type MutationCreateProductArgs = {
  input: ProductInput;
};

export type MutationCreateWishlistArgs = {
  input: CreateWishlistInput;
};

export type MutationDeleteAddressArgs = {
  addressId: Scalars['String']['input'];
};

export type MutationDeleteCategoryArgs = {
  slug: Scalars['String']['input'];
};

export type MutationDeleteProductArgs = {
  slug: Scalars['String']['input'];
};

export type MutationDeleteWishlistArgs = {
  wishlistId: Scalars['String']['input'];
};

export type MutationGuestQuoteCheckoutArgs = {
  input: GuestQuoteCheckoutInput;
};

export type MutationLoginArgs = {
  loginInput: LoginInput;
};

export type MutationQuoteCheckoutArgs = {
  input: QuoteCheckoutInput;
};

export type MutationRegisterArgs = {
  registerInput: RegisterInput;
};

export type MutationRegisterPushSubscriptionArgs = {
  input: RegisterPushSubscriptionInput;
};

export type MutationRemoveFromBagArgs = {
  productId: Scalars['String']['input'];
};

export type MutationRemoveFromWishlistArgs = {
  input: WishlistItemInput;
};

export type MutationRenameWishlistArgs = {
  input: RenameWishlistInput;
  wishlistId: Scalars['String']['input'];
};

export type MutationSetBagItemQuantityArgs = {
  input: BagItemQuantityInput;
};

export type MutationSetDefaultBillingAddressArgs = {
  addressId: Scalars['String']['input'];
};

export type MutationSetDefaultShippingAddressArgs = {
  addressId: Scalars['String']['input'];
};

export type MutationSetDefaultWishlistArgs = {
  wishlistId: Scalars['String']['input'];
};

export type MutationStartRazorpayCheckoutArgs = {
  input: QuoteCheckoutInput;
};

export type MutationUpdateAddressArgs = {
  addressId: Scalars['String']['input'];
  input: AddressInput;
};

export type MutationUpdateCategoryArgs = {
  input: CategoryInput;
  slug: Scalars['String']['input'];
};

export type MutationUpdateNotificationPreferenceArgs = {
  input: UpdateNotificationPreferenceInput;
};

export type MutationUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInput;
};

export type MutationUpdateProductArgs = {
  input: ProductInput;
  slug: Scalars['String']['input'];
};

export type MutationUpdateUserPreferenceArgs = {
  input: UpdateUserPreferenceInput;
};

export type MutationVerifyRazorpayPaymentArgs = {
  input: VerifyRazorpayPaymentInput;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  emailEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pushEnabled: Scalars['Boolean']['output'];
  smsEnabled: Scalars['Boolean']['output'];
  topic: NotificationPreferenceTopic;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum NotificationPreferenceTopic {
  AccountSecurity = 'ACCOUNT_SECURITY',
  Marketing = 'MARKETING',
  OrderUpdates = 'ORDER_UPDATES',
}

export type Order = {
  __typename?: 'Order';
  billingAddress?: Maybe<Address>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discountTotal: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  items?: Maybe<Array<OrderItem>>;
  paymentStatus: PaymentStatus;
  razorpayOrderId?: Maybe<Scalars['String']['output']>;
  razorpayPaymentId?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<Address>;
  shippingTotal: Scalars['Float']['output'];
  status: OrderStatus;
  subtotal: Scalars['Float']['output'];
  taxTotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  trackingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lineSavings: Scalars['Float']['output'];
  lineTotal: Scalars['Float']['output'];
  originalUnitPrice: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productSlug: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  Expired = 'EXPIRED',
  OnTheWay = 'ON_THE_WAY',
  Packed = 'PACKED',
  PaymentFailed = 'PAYMENT_FAILED',
  PendingPayment = 'PENDING_PAYMENT',
  Returned = 'RETURNED',
  Shipped = 'SHIPPED',
}

export enum PaymentStatus {
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type Permission = {
  __typename?: 'Permission';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PostalCodeResolution = {
  __typename?: 'PostalCodeResolution';
  cached: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  countryName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  resolvedAt: Scalars['DateTime']['output'];
  source: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  category: Category;
  collection: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  isBestseller: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  material: Scalars['String']['output'];
  name: Scalars['String']['output'];
  originalPrice: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  rating: Scalars['Float']['output'];
  reviewCount: Scalars['Float']['output'];
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  stockQuantity: Scalars['Float']['output'];
  subcategory: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductFilterInput = {
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  collection?: InputMaybe<Scalars['String']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type ProductInput = {
  categoryId: Scalars['String']['input'];
  collection: Scalars['String']['input'];
  image: Scalars['String']['input'];
  isBestseller?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  material: Scalars['String']['input'];
  name: Scalars['String']['input'];
  originalPrice: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  rating?: InputMaybe<Scalars['Float']['input']>;
  reviewCount?: InputMaybe<Scalars['Float']['input']>;
  shortDescription: Scalars['String']['input'];
  stockQuantity?: InputMaybe<Scalars['Int']['input']>;
  subcategory: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  addresses: Array<Address>;
  adminOrder?: Maybe<Order>;
  adminOrders: Array<Order>;
  bag: Bag;
  categories: Array<Category>;
  category?: Maybe<Category>;
  homepageContent: HomepageContent;
  me: User;
  notificationPreferences: Array<NotificationPreference>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  pingAuth: Scalars['String']['output'];
  pingCheckout: Scalars['String']['output'];
  postalCodeLookup: PostalCodeResolution;
  product?: Maybe<Product>;
  products: Array<Product>;
  user?: Maybe<User>;
  users: Array<User>;
  visibleCoupons: Array<Coupon>;
  wishlists: Array<Wishlist>;
};

export type QueryAdminOrderArgs = {
  id: Scalars['String']['input'];
};

export type QueryCategoryArgs = {
  slug: Scalars['String']['input'];
};

export type QueryOrderArgs = {
  id: Scalars['String']['input'];
};

export type QueryPostalCodeLookupArgs = {
  countryName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
};

export type QueryProductArgs = {
  slug: Scalars['String']['input'];
};

export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilterInput>;
};

export type QueryUserArgs = {
  id: Scalars['String']['input'];
};

export type QuoteCheckoutInput = {
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  shippingAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type RazorpayCheckoutOptions = {
  __typename?: 'RazorpayCheckoutOptions';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  keyId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  prefill?: Maybe<RazorpayCheckoutPrefill>;
};

export type RazorpayCheckoutPrefill = {
  __typename?: 'RazorpayCheckoutPrefill';
  contact?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RazorpayCheckoutSession = {
  __typename?: 'RazorpayCheckoutSession';
  options: RazorpayCheckoutOptions;
  order: Order;
  quote: CheckoutQuote;
};

export type RegisterInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterPushSubscriptionInput = {
  expectedUserId: Scalars['String']['input'];
  providerSubscriptionId: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type RenameWishlistInput = {
  name: Scalars['String']['input'];
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Permission>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateNotificationPreferenceInput = {
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  expectedUserId: Scalars['String']['input'];
  pushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  topic: NotificationPreferenceTopic;
};

export type UpdateOrderStatusInput = {
  orderId: Scalars['String']['input'];
  status: OrderStatus;
  trackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserPreferenceInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  addresses?: Maybe<Array<Address>>;
  bag?: Maybe<Bag>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  notificationPreferences?: Maybe<Array<NotificationPreference>>;
  preference?: Maybe<UserPreference>;
  profile?: Maybe<UserProfile>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wishlists?: Maybe<Array<Wishlist>>;
};

export type UserPreference = {
  __typename?: 'UserPreference';
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  defaultBillingAddressId?: Maybe<Scalars['String']['output']>;
  defaultShippingAddressId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VerifyRazorpayPaymentInput = {
  orderId: Scalars['String']['input'];
  razorpayOrderId: Scalars['String']['input'];
  razorpayPaymentId: Scalars['String']['input'];
  razorpaySignature: Scalars['String']['input'];
};

export type Wishlist = {
  __typename?: 'Wishlist';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  items?: Maybe<Array<WishlistItem>>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WishlistItem = {
  __typename?: 'WishlistItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  product: Product;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WishlistItemInput = {
  productId: Scalars['String']['input'];
  wishlistId?: InputMaybe<Scalars['String']['input']>;
};

export type AddToBagMutationVariables = Exact<{
  input: AddToBagInput;
}>;

export type AddToBagMutation = {
  __typename?: 'Mutation';
  addToBag: {
    __typename?: 'Bag';
    id: string;
    items?: Array<{
      __typename?: 'BagItem';
      id: string;
      quantity: number;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  };
};

export type AddToWishlistMutationVariables = Exact<{
  input: AddToWishlistInput;
}>;

export type AddToWishlistMutation = {
  __typename?: 'Mutation';
  addToWishlist: {
    __typename?: 'Wishlist';
    id: string;
    name: string;
    isDefault: boolean;
    items?: Array<{
      __typename?: 'WishlistItem';
      id: string;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  };
};

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;

export type ChangePasswordMutation = {
  __typename?: 'Mutation';
  changePassword: boolean;
};

export type ClearBagMutationVariables = Exact<{ [key: string]: never }>;

export type ClearBagMutation = {
  __typename?: 'Mutation';
  clearBag: {
    __typename?: 'Bag';
    id: string;
    items?: Array<{
      __typename?: 'BagItem';
      id: string;
      quantity: number;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  };
};

export type CompleteCheckoutMutationVariables = Exact<{
  input: CompleteCheckoutInput;
}>;

export type CompleteCheckoutMutation = {
  __typename?: 'Mutation';
  completeCheckout: {
    __typename?: 'CompleteCheckoutResult';
    success: boolean;
    orderId?: string | null;
    message?: string | null;
    quote: {
      __typename?: 'CheckoutQuote';
      currency: string;
      subtotal: number;
      discountTotal: number;
      shippingTotal: number;
      taxTotal: number;
      total: number;
      couponCode?: string | null;
      items: Array<{
        __typename?: 'CheckoutLineItem';
        productId: string;
        productName: string;
        productSlug: string;
        quantity: number;
        unitPrice: number;
        originalUnitPrice: number;
        lineTotal: number;
        lineSavings: number;
      }>;
    };
    order?: {
      __typename?: 'Order';
      id: string;
      status: OrderStatus;
      paymentStatus: PaymentStatus;
      total: number;
      items?: Array<{
        __typename?: 'OrderItem';
        id: string;
        productName: string;
        quantity: number;
        lineTotal: number;
      }> | null;
    } | null;
  };
};

export type CreateAddressMutationVariables = Exact<{
  input: AddressInput;
}>;

export type CreateAddressMutation = {
  __typename?: 'Mutation';
  createAddress: {
    __typename?: 'Address';
    id: string;
    label?: string | null;
    firstName: string;
    lastName: string;
    phone: string;
    line1: string;
    line2?: string | null;
    city: string;
    state: string;
    postalCode: string;
    country: string;
    landmark?: string | null;
  };
};

export type CreateWishlistMutationVariables = Exact<{
  input: CreateWishlistInput;
}>;

export type CreateWishlistMutation = {
  __typename?: 'Mutation';
  createWishlist: {
    __typename?: 'Wishlist';
    id: string;
    name: string;
    isDefault: boolean;
    items?: Array<{
      __typename?: 'WishlistItem';
      id: string;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  };
};

export type DeleteAddressMutationVariables = Exact<{
  addressId: Scalars['String']['input'];
}>;

export type DeleteAddressMutation = {
  __typename?: 'Mutation';
  deleteAddress: boolean;
};

export type DeleteWishlistMutationVariables = Exact<{
  wishlistId: Scalars['String']['input'];
}>;

export type DeleteWishlistMutation = {
  __typename?: 'Mutation';
  deleteWishlist: boolean;
};

export type LoginMutationVariables = Exact<{
  loginInput: LoginInput;
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login: { __typename?: 'AuthPayload'; accessToken: string };
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { __typename?: 'Mutation'; logout: boolean };

export type RegisterPushSubscriptionMutationVariables = Exact<{
  input: RegisterPushSubscriptionInput;
}>;

export type RegisterPushSubscriptionMutation = {
  __typename?: 'Mutation';
  registerPushSubscription: boolean;
};

export type RegisterMutationVariables = Exact<{
  registerInput: RegisterInput;
}>;

export type RegisterMutation = {
  __typename?: 'Mutation';
  register: { __typename?: 'AuthPayload'; accessToken: string };
};

export type RemoveFromBagMutationVariables = Exact<{
  productId: Scalars['String']['input'];
}>;

export type RemoveFromBagMutation = {
  __typename?: 'Mutation';
  removeFromBag: {
    __typename?: 'Bag';
    id: string;
    items?: Array<{
      __typename?: 'BagItem';
      id: string;
      quantity: number;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  };
};

export type RemoveFromWishlistMutationVariables = Exact<{
  input: WishlistItemInput;
}>;

export type RemoveFromWishlistMutation = {
  __typename?: 'Mutation';
  removeFromWishlist: {
    __typename?: 'Wishlist';
    id: string;
    name: string;
    isDefault: boolean;
    items?: Array<{
      __typename?: 'WishlistItem';
      id: string;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  };
};

export type RenameWishlistMutationVariables = Exact<{
  wishlistId: Scalars['String']['input'];
  input: RenameWishlistInput;
}>;

export type RenameWishlistMutation = {
  __typename?: 'Mutation';
  renameWishlist: {
    __typename?: 'Wishlist';
    id: string;
    name: string;
    isDefault: boolean;
    items?: Array<{
      __typename?: 'WishlistItem';
      id: string;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  };
};

export type SetBagItemQuantityMutationVariables = Exact<{
  input: BagItemQuantityInput;
}>;

export type SetBagItemQuantityMutation = {
  __typename?: 'Mutation';
  setBagItemQuantity: {
    __typename?: 'Bag';
    id: string;
    items?: Array<{
      __typename?: 'BagItem';
      id: string;
      quantity: number;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  };
};

export type SetDefaultBillingAddressMutationVariables = Exact<{
  addressId: Scalars['String']['input'];
}>;

export type SetDefaultBillingAddressMutation = {
  __typename?: 'Mutation';
  setDefaultBillingAddress: {
    __typename?: 'UserPreference';
    id: string;
    defaultShippingAddressId?: string | null;
    defaultBillingAddressId?: string | null;
  };
};

export type SetDefaultShippingAddressMutationVariables = Exact<{
  addressId: Scalars['String']['input'];
}>;

export type SetDefaultShippingAddressMutation = {
  __typename?: 'Mutation';
  setDefaultShippingAddress: {
    __typename?: 'UserPreference';
    id: string;
    defaultShippingAddressId?: string | null;
    defaultBillingAddressId?: string | null;
  };
};

export type SetDefaultWishlistMutationVariables = Exact<{
  wishlistId: Scalars['String']['input'];
}>;

export type SetDefaultWishlistMutation = {
  __typename?: 'Mutation';
  setDefaultWishlist: {
    __typename?: 'Wishlist';
    id: string;
    name: string;
    isDefault: boolean;
    items?: Array<{
      __typename?: 'WishlistItem';
      id: string;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  };
};

export type UpdateAddressMutationVariables = Exact<{
  addressId: Scalars['String']['input'];
  input: AddressInput;
}>;

export type UpdateAddressMutation = {
  __typename?: 'Mutation';
  updateAddress: {
    __typename?: 'Address';
    id: string;
    label?: string | null;
    firstName: string;
    lastName: string;
    phone: string;
    line1: string;
    line2?: string | null;
    city: string;
    state: string;
    postalCode: string;
    country: string;
    landmark?: string | null;
  };
};

export type UpdateNotificationPreferenceMutationVariables = Exact<{
  input: UpdateNotificationPreferenceInput;
}>;

export type UpdateNotificationPreferenceMutation = {
  __typename?: 'Mutation';
  updateNotificationPreference: {
    __typename?: 'NotificationPreference';
    id: string;
    topic: NotificationPreferenceTopic;
    emailEnabled: boolean;
    smsEnabled: boolean;
    pushEnabled: boolean;
  };
};

export type UpdateOrderStatusMutationVariables = Exact<{
  input: UpdateOrderStatusInput;
}>;

export type UpdateOrderStatusMutation = {
  __typename?: 'Mutation';
  updateOrderStatus: {
    __typename?: 'Order';
    id: string;
    status: OrderStatus;
    trackingUrl?: string | null;
  };
};

export type UpdateUserPreferenceMutationVariables = Exact<{
  input: UpdateUserPreferenceInput;
}>;

export type UpdateUserPreferenceMutation = {
  __typename?: 'Mutation';
  updateUserPreference: {
    __typename?: 'UserPreference';
    id: string;
    defaultShippingAddressId?: string | null;
    defaultBillingAddressId?: string | null;
    locale?: string | null;
    currency?: string | null;
  };
};

export type AdminOrderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AdminOrderQuery = {
  __typename?: 'Query';
  adminOrder?: {
    __typename?: 'Order';
    id: string;
    createdAt: string;
    status: OrderStatus;
    paymentStatus: PaymentStatus;
    trackingUrl?: string | null;
    subtotal: number;
    discountTotal: number;
    shippingTotal: number;
    taxTotal: number;
    total: number;
    couponCode?: string | null;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      isActive: boolean;
      profile?: {
        __typename?: 'UserProfile';
        firstName: string;
        lastName: string;
        phone?: string | null;
      } | null;
      role?: { __typename?: 'Role'; name: string } | null;
    };
    shippingAddress?: {
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    billingAddress?: {
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    items?: Array<{
      __typename?: 'OrderItem';
      id: string;
      productName: string;
      productSlug: string;
      quantity: number;
      unitPrice: number;
      originalUnitPrice: number;
      lineTotal: number;
      lineSavings: number;
    }> | null;
  } | null;
};

export type AdminOrdersQueryVariables = Exact<{ [key: string]: never }>;

export type AdminOrdersQuery = {
  __typename?: 'Query';
  adminOrders: Array<{
    __typename?: 'Order';
    id: string;
    createdAt: string;
    status: OrderStatus;
    paymentStatus: PaymentStatus;
    trackingUrl?: string | null;
    subtotal: number;
    discountTotal: number;
    shippingTotal: number;
    taxTotal: number;
    total: number;
    couponCode?: string | null;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      isActive: boolean;
      profile?: {
        __typename?: 'UserProfile';
        firstName: string;
        lastName: string;
        phone?: string | null;
      } | null;
      role?: { __typename?: 'Role'; name: string } | null;
    };
    shippingAddress?: {
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    billingAddress?: {
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    items?: Array<{
      __typename?: 'OrderItem';
      id: string;
      productName: string;
      productSlug: string;
      quantity: number;
      unitPrice: number;
      originalUnitPrice: number;
      lineTotal: number;
      lineSavings: number;
    }> | null;
  }>;
};

export type BagQueryVariables = Exact<{ [key: string]: never }>;

export type BagQuery = {
  __typename?: 'Query';
  bag: {
    __typename?: 'Bag';
    id: string;
    items?: Array<{
      __typename?: 'BagItem';
      id: string;
      quantity: number;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  };
};

export type CreateCategoryMutationVariables = Exact<{
  input: CategoryInput;
}>;

export type CreateCategoryMutation = {
  __typename?: 'Mutation';
  createCategory: {
    __typename?: 'Category';
    id: string;
    slug: string;
    name: string;
    description?: string | null;
  };
};

export type UpdateCategoryMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  input: CategoryInput;
}>;

export type UpdateCategoryMutation = {
  __typename?: 'Mutation';
  updateCategory: {
    __typename?: 'Category';
    id: string;
    slug: string;
    name: string;
    description?: string | null;
  };
};

export type DeleteCategoryMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type DeleteCategoryMutation = {
  __typename?: 'Mutation';
  deleteCategory: boolean;
};

export type CategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type CategoriesQuery = {
  __typename?: 'Query';
  categories: Array<{
    __typename?: 'Category';
    id: string;
    slug: string;
    name: string;
    description?: string | null;
  }>;
};

export type CategoryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type CategoryQuery = {
  __typename?: 'Query';
  category?: {
    __typename?: 'Category';
    id: string;
    slug: string;
    name: string;
    description?: string | null;
  } | null;
};

export type CheckoutQuoteMutationVariables = Exact<{
  input: QuoteCheckoutInput;
}>;

export type CheckoutQuoteMutation = {
  __typename?: 'Mutation';
  quoteCheckout: {
    __typename?: 'CheckoutQuote';
    currency: string;
    subtotal: number;
    discountTotal: number;
    shippingTotal: number;
    taxTotal: number;
    total: number;
    couponCode?: string | null;
    shippingAddress?: {
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    billingAddress?: {
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    items: Array<{
      __typename?: 'CheckoutLineItem';
      productId: string;
      productName: string;
      productSlug: string;
      quantity: number;
      unitPrice: number;
      originalUnitPrice: number;
      lineTotal: number;
      lineSavings: number;
    }>;
  };
};

export type GuestCheckoutQuoteMutationVariables = Exact<{
  input: GuestQuoteCheckoutInput;
}>;

export type GuestCheckoutQuoteMutation = {
  __typename?: 'Mutation';
  guestQuoteCheckout: {
    __typename?: 'CheckoutQuote';
    currency: string;
    subtotal: number;
    discountTotal: number;
    shippingTotal: number;
    taxTotal: number;
    total: number;
    couponCode?: string | null;
    items: Array<{
      __typename?: 'CheckoutLineItem';
      productId: string;
      productName: string;
      productSlug: string;
      quantity: number;
      unitPrice: number;
      originalUnitPrice: number;
      lineTotal: number;
      lineSavings: number;
    }>;
  };
};

export type StartRazorpayCheckoutMutationVariables = Exact<{
  input: QuoteCheckoutInput;
}>;

export type StartRazorpayCheckoutMutation = {
  __typename?: 'Mutation';
  startRazorpayCheckout: {
    __typename?: 'RazorpayCheckoutSession';
    quote: {
      __typename?: 'CheckoutQuote';
      currency: string;
      subtotal: number;
      discountTotal: number;
      shippingTotal: number;
      taxTotal: number;
      total: number;
      couponCode?: string | null;
      items: Array<{
        __typename?: 'CheckoutLineItem';
        productId: string;
        productName: string;
        productSlug: string;
        quantity: number;
        unitPrice: number;
        originalUnitPrice: number;
        lineTotal: number;
        lineSavings: number;
      }>;
    };
    order: { __typename?: 'Order'; id: string };
    options: {
      __typename?: 'RazorpayCheckoutOptions';
      keyId: string;
      orderId: string;
      amount: number;
      currency: string;
      name: string;
      description?: string | null;
      image?: string | null;
      prefill?: {
        __typename?: 'RazorpayCheckoutPrefill';
        name?: string | null;
        email?: string | null;
        contact?: string | null;
      } | null;
    };
  };
};

export type VerifyRazorpayPaymentMutationVariables = Exact<{
  input: VerifyRazorpayPaymentInput;
}>;

export type VerifyRazorpayPaymentMutation = {
  __typename?: 'Mutation';
  verifyRazorpayPayment: {
    __typename?: 'CompleteCheckoutResult';
    success: boolean;
    orderId?: string | null;
    message?: string | null;
    quote: {
      __typename?: 'CheckoutQuote';
      currency: string;
      subtotal: number;
      discountTotal: number;
      shippingTotal: number;
      taxTotal: number;
      total: number;
      couponCode?: string | null;
      items: Array<{
        __typename?: 'CheckoutLineItem';
        productId: string;
        productName: string;
        productSlug: string;
        quantity: number;
        unitPrice: number;
        originalUnitPrice: number;
        lineTotal: number;
        lineSavings: number;
      }>;
    };
    order?: { __typename?: 'Order'; id: string } | null;
  };
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    email: string;
    isActive: boolean;
    role?: {
      __typename?: 'Role';
      id: string;
      name: string;
      permissions?: Array<{ __typename?: 'Permission'; name: string }> | null;
    } | null;
    profile?: {
      __typename?: 'UserProfile';
      id: string;
      firstName: string;
      lastName: string;
      phone?: string | null;
      avatarUrl?: string | null;
    } | null;
    preference?: {
      __typename?: 'UserPreference';
      id: string;
      defaultShippingAddressId?: string | null;
      defaultBillingAddressId?: string | null;
      locale?: string | null;
      currency?: string | null;
    } | null;
    notificationPreferences?: Array<{
      __typename?: 'NotificationPreference';
      id: string;
      topic: NotificationPreferenceTopic;
      emailEnabled: boolean;
      smsEnabled: boolean;
      pushEnabled: boolean;
    }> | null;
    addresses?: Array<{
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    }> | null;
  };
};

export type HomepageContentQueryVariables = Exact<{ [key: string]: never }>;

export type HomepageContentQuery = {
  __typename?: 'Query';
  homepageContent: {
    __typename?: 'HomepageContent';
    collectionLabel: string;
    collectionTitle: string;
    collectionCopy: string;
    newArrivalLabel: string;
    newArrivalTitle: string;
    newArrivalCopy: string;
    specialOfferLabel: string;
    specialOfferTitle: string;
    specialOfferCopy: string;
    articleLabel: string;
    articleTitle: string;
    articleCopy: string;
  };
};

export type OrderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type OrderQuery = {
  __typename?: 'Query';
  order?: {
    __typename?: 'Order';
    id: string;
    createdAt: string;
    status: OrderStatus;
    paymentStatus: PaymentStatus;
    trackingUrl?: string | null;
    subtotal: number;
    discountTotal: number;
    shippingTotal: number;
    taxTotal: number;
    total: number;
    couponCode?: string | null;
    shippingAddress?: {
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    billingAddress?: {
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    items?: Array<{
      __typename?: 'OrderItem';
      id: string;
      productName: string;
      productSlug: string;
      quantity: number;
      unitPrice: number;
      originalUnitPrice: number;
      lineTotal: number;
      lineSavings: number;
    }> | null;
  } | null;
};

export type OrdersQueryVariables = Exact<{ [key: string]: never }>;

export type OrdersQuery = {
  __typename?: 'Query';
  orders: Array<{
    __typename?: 'Order';
    id: string;
    createdAt: string;
    status: OrderStatus;
    paymentStatus: PaymentStatus;
    subtotal: number;
    discountTotal: number;
    shippingTotal: number;
    taxTotal: number;
    total: number;
    couponCode?: string | null;
    shippingAddress?: {
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    billingAddress?: {
      __typename?: 'Address';
      id: string;
      label?: string | null;
      firstName: string;
      lastName: string;
      phone: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    } | null;
    items?: Array<{
      __typename?: 'OrderItem';
      id: string;
      productName: string;
      productSlug: string;
      quantity: number;
      unitPrice: number;
      lineTotal: number;
      lineSavings: number;
    }> | null;
  }>;
};

export type PostalCodeLookupQueryVariables = Exact<{
  countryName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
}>;

export type PostalCodeLookupQuery = {
  __typename?: 'Query';
  postalCodeLookup: {
    __typename?: 'PostalCodeResolution';
    countryName: string;
    postalCode: string;
    city?: string | null;
    state?: string | null;
    source: string;
    cached: boolean;
    resolvedAt: string;
  };
};

export type ProductQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type ProductQuery = {
  __typename?: 'Query';
  product?: {
    __typename?: 'Product';
    id: string;
    slug: string;
    name: string;
    subcategory: string;
    collection: string;
    price: number;
    originalPrice: number;
    image: string;
    shortDescription: string;
    material: string;
    rating: number;
    reviewCount: number;
    isNew: boolean;
    isBestseller: boolean;
    stockQuantity: number;
    category: {
      __typename?: 'Category';
      id: string;
      slug: string;
      name: string;
      description?: string | null;
    };
  } | null;
};

export type ProductsQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilterInput>;
}>;

export type ProductsQuery = {
  __typename?: 'Query';
  products: Array<{
    __typename?: 'Product';
    id: string;
    slug: string;
    name: string;
    subcategory: string;
    collection: string;
    price: number;
    originalPrice: number;
    image: string;
    shortDescription: string;
    material: string;
    rating: number;
    reviewCount: number;
    isNew: boolean;
    isBestseller: boolean;
    stockQuantity: number;
    category: {
      __typename?: 'Category';
      slug: string;
      name: string;
      description?: string | null;
    };
  }>;
};

export type CreateProductMutationVariables = Exact<{
  input: ProductInput;
}>;

export type CreateProductMutation = {
  __typename?: 'Mutation';
  createProduct: {
    __typename?: 'Product';
    id: string;
    slug: string;
    name: string;
    image: string;
    stockQuantity: number;
  };
};

export type UpdateProductMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  input: ProductInput;
}>;

export type UpdateProductMutation = {
  __typename?: 'Mutation';
  updateProduct: {
    __typename?: 'Product';
    id: string;
    slug: string;
    name: string;
    image: string;
    stockQuantity: number;
  };
};

export type DeleteProductMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type DeleteProductMutation = {
  __typename?: 'Mutation';
  deleteProduct: boolean;
};

export type VisibleCouponsQueryVariables = Exact<{ [key: string]: never }>;

export type VisibleCouponsQuery = {
  __typename?: 'Query';
  visibleCoupons: Array<{
    __typename?: 'Coupon';
    id: string;
    code: string;
    description?: string | null;
    discountType: CouponDiscountType;
    discountValue: number;
    minimumCartValue?: number | null;
    maximumDiscountAmount?: number | null;
    startsAt?: string | null;
    endsAt?: string | null;
  }>;
};

export type WishlistsQueryVariables = Exact<{ [key: string]: never }>;

export type WishlistsQuery = {
  __typename?: 'Query';
  wishlists: Array<{
    __typename?: 'Wishlist';
    id: string;
    name: string;
    isDefault: boolean;
    items?: Array<{
      __typename?: 'WishlistItem';
      id: string;
      product: {
        __typename?: 'Product';
        id: string;
        slug: string;
        name: string;
        price: number;
        originalPrice: number;
        image: string;
      };
    }> | null;
  }>;
};

export const AddToBagDocument = gql`
  mutation addToBag($input: AddToBagInput!) {
    addToBag(input: $input) {
      id
      items {
        id
        quantity
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AddToBagGQL extends Apollo.Mutation<
  AddToBagMutation,
  AddToBagMutationVariables
> {
  document = AddToBagDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AddToWishlistDocument = gql`
  mutation addToWishlist($input: AddToWishlistInput!) {
    addToWishlist(input: $input) {
      id
      name
      isDefault
      items {
        id
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AddToWishlistGQL extends Apollo.Mutation<
  AddToWishlistMutation,
  AddToWishlistMutationVariables
> {
  document = AddToWishlistDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ChangePasswordDocument = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordGQL extends Apollo.Mutation<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
> {
  document = ChangePasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ClearBagDocument = gql`
  mutation clearBag {
    clearBag {
      id
      items {
        id
        quantity
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ClearBagGQL extends Apollo.Mutation<
  ClearBagMutation,
  ClearBagMutationVariables
> {
  document = ClearBagDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CompleteCheckoutDocument = gql`
  mutation completeCheckout($input: CompleteCheckoutInput!) {
    completeCheckout(input: $input) {
      success
      orderId
      message
      quote {
        currency
        subtotal
        discountTotal
        shippingTotal
        taxTotal
        total
        couponCode
        items {
          productId
          productName
          productSlug
          quantity
          unitPrice
          originalUnitPrice
          lineTotal
          lineSavings
        }
      }
      order {
        id
        status
        paymentStatus
        total
        items {
          id
          productName
          quantity
          lineTotal
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CompleteCheckoutGQL extends Apollo.Mutation<
  CompleteCheckoutMutation,
  CompleteCheckoutMutationVariables
> {
  document = CompleteCheckoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateAddressDocument = gql`
  mutation createAddress($input: AddressInput!) {
    createAddress(input: $input) {
      id
      label
      firstName
      lastName
      phone
      line1
      line2
      city
      state
      postalCode
      country
      landmark
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateAddressGQL extends Apollo.Mutation<
  CreateAddressMutation,
  CreateAddressMutationVariables
> {
  document = CreateAddressDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateWishlistDocument = gql`
  mutation createWishlist($input: CreateWishlistInput!) {
    createWishlist(input: $input) {
      id
      name
      isDefault
      items {
        id
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateWishlistGQL extends Apollo.Mutation<
  CreateWishlistMutation,
  CreateWishlistMutationVariables
> {
  document = CreateWishlistDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteAddressDocument = gql`
  mutation deleteAddress($addressId: String!) {
    deleteAddress(addressId: $addressId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteAddressGQL extends Apollo.Mutation<
  DeleteAddressMutation,
  DeleteAddressMutationVariables
> {
  document = DeleteAddressDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteWishlistDocument = gql`
  mutation deleteWishlist($wishlistId: String!) {
    deleteWishlist(wishlistId: $wishlistId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteWishlistGQL extends Apollo.Mutation<
  DeleteWishlistMutation,
  DeleteWishlistMutationVariables
> {
  document = DeleteWishlistDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LoginDocument = gql`
  mutation Login($loginInput: LoginInput!) {
    login(loginInput: $loginInput) {
      accessToken
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LoginGQL extends Apollo.Mutation<
  LoginMutation,
  LoginMutationVariables
> {
  document = LoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LogoutDocument = gql`
  mutation Logout {
    logout
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LogoutGQL extends Apollo.Mutation<
  LogoutMutation,
  LogoutMutationVariables
> {
  document = LogoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegisterPushSubscriptionDocument = gql`
  mutation RegisterPushSubscription($input: RegisterPushSubscriptionInput!) {
    registerPushSubscription(input: $input)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RegisterPushSubscriptionGQL extends Apollo.Mutation<
  RegisterPushSubscriptionMutation,
  RegisterPushSubscriptionMutationVariables
> {
  document = RegisterPushSubscriptionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegisterDocument = gql`
  mutation Register($registerInput: RegisterInput!) {
    register(registerInput: $registerInput) {
      accessToken
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RegisterGQL extends Apollo.Mutation<
  RegisterMutation,
  RegisterMutationVariables
> {
  document = RegisterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveFromBagDocument = gql`
  mutation removeFromBag($productId: String!) {
    removeFromBag(productId: $productId) {
      id
      items {
        id
        quantity
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveFromBagGQL extends Apollo.Mutation<
  RemoveFromBagMutation,
  RemoveFromBagMutationVariables
> {
  document = RemoveFromBagDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveFromWishlistDocument = gql`
  mutation removeFromWishlist($input: WishlistItemInput!) {
    removeFromWishlist(input: $input) {
      id
      name
      isDefault
      items {
        id
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveFromWishlistGQL extends Apollo.Mutation<
  RemoveFromWishlistMutation,
  RemoveFromWishlistMutationVariables
> {
  document = RemoveFromWishlistDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RenameWishlistDocument = gql`
  mutation renameWishlist($wishlistId: String!, $input: RenameWishlistInput!) {
    renameWishlist(wishlistId: $wishlistId, input: $input) {
      id
      name
      isDefault
      items {
        id
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RenameWishlistGQL extends Apollo.Mutation<
  RenameWishlistMutation,
  RenameWishlistMutationVariables
> {
  document = RenameWishlistDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetBagItemQuantityDocument = gql`
  mutation setBagItemQuantity($input: BagItemQuantityInput!) {
    setBagItemQuantity(input: $input) {
      id
      items {
        id
        quantity
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SetBagItemQuantityGQL extends Apollo.Mutation<
  SetBagItemQuantityMutation,
  SetBagItemQuantityMutationVariables
> {
  document = SetBagItemQuantityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetDefaultBillingAddressDocument = gql`
  mutation setDefaultBillingAddress($addressId: String!) {
    setDefaultBillingAddress(addressId: $addressId) {
      id
      defaultShippingAddressId
      defaultBillingAddressId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SetDefaultBillingAddressGQL extends Apollo.Mutation<
  SetDefaultBillingAddressMutation,
  SetDefaultBillingAddressMutationVariables
> {
  document = SetDefaultBillingAddressDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetDefaultShippingAddressDocument = gql`
  mutation setDefaultShippingAddress($addressId: String!) {
    setDefaultShippingAddress(addressId: $addressId) {
      id
      defaultShippingAddressId
      defaultBillingAddressId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SetDefaultShippingAddressGQL extends Apollo.Mutation<
  SetDefaultShippingAddressMutation,
  SetDefaultShippingAddressMutationVariables
> {
  document = SetDefaultShippingAddressDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetDefaultWishlistDocument = gql`
  mutation setDefaultWishlist($wishlistId: String!) {
    setDefaultWishlist(wishlistId: $wishlistId) {
      id
      name
      isDefault
      items {
        id
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SetDefaultWishlistGQL extends Apollo.Mutation<
  SetDefaultWishlistMutation,
  SetDefaultWishlistMutationVariables
> {
  document = SetDefaultWishlistDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateAddressDocument = gql`
  mutation updateAddress($addressId: String!, $input: AddressInput!) {
    updateAddress(addressId: $addressId, input: $input) {
      id
      label
      firstName
      lastName
      phone
      line1
      line2
      city
      state
      postalCode
      country
      landmark
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateAddressGQL extends Apollo.Mutation<
  UpdateAddressMutation,
  UpdateAddressMutationVariables
> {
  document = UpdateAddressDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateNotificationPreferenceDocument = gql`
  mutation UpdateNotificationPreference(
    $input: UpdateNotificationPreferenceInput!
  ) {
    updateNotificationPreference(input: $input) {
      id
      topic
      emailEnabled
      smsEnabled
      pushEnabled
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateNotificationPreferenceGQL extends Apollo.Mutation<
  UpdateNotificationPreferenceMutation,
  UpdateNotificationPreferenceMutationVariables
> {
  document = UpdateNotificationPreferenceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateOrderStatusDocument = gql`
  mutation updateOrderStatus($input: UpdateOrderStatusInput!) {
    updateOrderStatus(input: $input) {
      id
      status
      trackingUrl
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateOrderStatusGQL extends Apollo.Mutation<
  UpdateOrderStatusMutation,
  UpdateOrderStatusMutationVariables
> {
  document = UpdateOrderStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateUserPreferenceDocument = gql`
  mutation UpdateUserPreference($input: UpdateUserPreferenceInput!) {
    updateUserPreference(input: $input) {
      id
      defaultShippingAddressId
      defaultBillingAddressId
      locale
      currency
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateUserPreferenceGQL extends Apollo.Mutation<
  UpdateUserPreferenceMutation,
  UpdateUserPreferenceMutationVariables
> {
  document = UpdateUserPreferenceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AdminOrderDocument = gql`
  query adminOrder($id: String!) {
    adminOrder(id: $id) {
      id
      createdAt
      status
      paymentStatus
      trackingUrl
      subtotal
      discountTotal
      shippingTotal
      taxTotal
      total
      couponCode
      user {
        id
        email
        isActive
        profile {
          firstName
          lastName
          phone
        }
        role {
          name
        }
      }
      shippingAddress {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
      billingAddress {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
      items {
        id
        productName
        productSlug
        quantity
        unitPrice
        originalUnitPrice
        lineTotal
        lineSavings
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AdminOrderGQL extends Apollo.Query<
  AdminOrderQuery,
  AdminOrderQueryVariables
> {
  document = AdminOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AdminOrdersDocument = gql`
  query adminOrders {
    adminOrders {
      id
      createdAt
      status
      paymentStatus
      trackingUrl
      subtotal
      discountTotal
      shippingTotal
      taxTotal
      total
      couponCode
      user {
        id
        email
        isActive
        profile {
          firstName
          lastName
          phone
        }
        role {
          name
        }
      }
      shippingAddress {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
      billingAddress {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
      items {
        id
        productName
        productSlug
        quantity
        unitPrice
        originalUnitPrice
        lineTotal
        lineSavings
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AdminOrdersGQL extends Apollo.Query<
  AdminOrdersQuery,
  AdminOrdersQueryVariables
> {
  document = AdminOrdersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BagDocument = gql`
  query bag {
    bag {
      id
      items {
        id
        quantity
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BagGQL extends Apollo.Query<BagQuery, BagQueryVariables> {
  document = BagDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateCategoryDocument = gql`
  mutation createCategory($input: CategoryInput!) {
    createCategory(input: $input) {
      id
      slug
      name
      description
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateCategoryGQL extends Apollo.Mutation<
  CreateCategoryMutation,
  CreateCategoryMutationVariables
> {
  document = CreateCategoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCategoryDocument = gql`
  mutation updateCategory($slug: String!, $input: CategoryInput!) {
    updateCategory(slug: $slug, input: $input) {
      id
      slug
      name
      description
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateCategoryGQL extends Apollo.Mutation<
  UpdateCategoryMutation,
  UpdateCategoryMutationVariables
> {
  document = UpdateCategoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteCategoryDocument = gql`
  mutation deleteCategory($slug: String!) {
    deleteCategory(slug: $slug)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteCategoryGQL extends Apollo.Mutation<
  DeleteCategoryMutation,
  DeleteCategoryMutationVariables
> {
  document = DeleteCategoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CategoriesDocument = gql`
  query categories {
    categories {
      id
      slug
      name
      description
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CategoriesGQL extends Apollo.Query<
  CategoriesQuery,
  CategoriesQueryVariables
> {
  document = CategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CategoryDocument = gql`
  query category($slug: String!) {
    category(slug: $slug) {
      id
      slug
      name
      description
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CategoryGQL extends Apollo.Query<
  CategoryQuery,
  CategoryQueryVariables
> {
  document = CategoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CheckoutQuoteDocument = gql`
  mutation checkoutQuote($input: QuoteCheckoutInput!) {
    quoteCheckout(input: $input) {
      currency
      subtotal
      discountTotal
      shippingTotal
      taxTotal
      total
      couponCode
      shippingAddress {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
      billingAddress {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
      items {
        productId
        productName
        productSlug
        quantity
        unitPrice
        originalUnitPrice
        lineTotal
        lineSavings
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CheckoutQuoteGQL extends Apollo.Mutation<
  CheckoutQuoteMutation,
  CheckoutQuoteMutationVariables
> {
  document = CheckoutQuoteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GuestCheckoutQuoteDocument = gql`
  mutation guestCheckoutQuote($input: GuestQuoteCheckoutInput!) {
    guestQuoteCheckout(input: $input) {
      currency
      subtotal
      discountTotal
      shippingTotal
      taxTotal
      total
      couponCode
      items {
        productId
        productName
        productSlug
        quantity
        unitPrice
        originalUnitPrice
        lineTotal
        lineSavings
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GuestCheckoutQuoteGQL extends Apollo.Mutation<
  GuestCheckoutQuoteMutation,
  GuestCheckoutQuoteMutationVariables
> {
  document = GuestCheckoutQuoteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const StartRazorpayCheckoutDocument = gql`
  mutation startRazorpayCheckout($input: QuoteCheckoutInput!) {
    startRazorpayCheckout(input: $input) {
      quote {
        currency
        subtotal
        discountTotal
        shippingTotal
        taxTotal
        total
        couponCode
        items {
          productId
          productName
          productSlug
          quantity
          unitPrice
          originalUnitPrice
          lineTotal
          lineSavings
        }
      }
      order {
        id
      }
      options {
        keyId
        orderId
        amount
        currency
        name
        description
        image
        prefill {
          name
          email
          contact
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class StartRazorpayCheckoutGQL extends Apollo.Mutation<
  StartRazorpayCheckoutMutation,
  StartRazorpayCheckoutMutationVariables
> {
  document = StartRazorpayCheckoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VerifyRazorpayPaymentDocument = gql`
  mutation verifyRazorpayPayment($input: VerifyRazorpayPaymentInput!) {
    verifyRazorpayPayment(input: $input) {
      success
      orderId
      message
      quote {
        currency
        subtotal
        discountTotal
        shippingTotal
        taxTotal
        total
        couponCode
        items {
          productId
          productName
          productSlug
          quantity
          unitPrice
          originalUnitPrice
          lineTotal
          lineSavings
        }
      }
      order {
        id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class VerifyRazorpayPaymentGQL extends Apollo.Mutation<
  VerifyRazorpayPaymentMutation,
  VerifyRazorpayPaymentMutationVariables
> {
  document = VerifyRazorpayPaymentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CurrentUserDocument = gql`
  query currentUser {
    me {
      id
      email
      isActive
      role {
        id
        name
        permissions {
          name
        }
      }
      profile {
        id
        firstName
        lastName
        phone
        avatarUrl
      }
      preference {
        id
        defaultShippingAddressId
        defaultBillingAddressId
        locale
        currency
      }
      notificationPreferences {
        id
        topic
        emailEnabled
        smsEnabled
        pushEnabled
      }
      addresses {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CurrentUserGQL extends Apollo.Query<
  CurrentUserQuery,
  CurrentUserQueryVariables
> {
  document = CurrentUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const HomepageContentDocument = gql`
  query homepageContent {
    homepageContent {
      collectionLabel
      collectionTitle
      collectionCopy
      newArrivalLabel
      newArrivalTitle
      newArrivalCopy
      specialOfferLabel
      specialOfferTitle
      specialOfferCopy
      articleLabel
      articleTitle
      articleCopy
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class HomepageContentGQL extends Apollo.Query<
  HomepageContentQuery,
  HomepageContentQueryVariables
> {
  document = HomepageContentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OrderDocument = gql`
  query order($id: String!) {
    order(id: $id) {
      id
      createdAt
      status
      paymentStatus
      trackingUrl
      subtotal
      discountTotal
      shippingTotal
      taxTotal
      total
      couponCode
      shippingAddress {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
      billingAddress {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
      items {
        id
        productName
        productSlug
        quantity
        unitPrice
        originalUnitPrice
        lineTotal
        lineSavings
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OrderGQL extends Apollo.Query<OrderQuery, OrderQueryVariables> {
  document = OrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OrdersDocument = gql`
  query orders {
    orders {
      id
      createdAt
      status
      paymentStatus
      subtotal
      discountTotal
      shippingTotal
      taxTotal
      total
      couponCode
      shippingAddress {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
      billingAddress {
        id
        label
        firstName
        lastName
        phone
        line1
        line2
        city
        state
        postalCode
        country
      }
      items {
        id
        productName
        productSlug
        quantity
        unitPrice
        lineTotal
        lineSavings
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OrdersGQL extends Apollo.Query<OrdersQuery, OrdersQueryVariables> {
  document = OrdersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PostalCodeLookupDocument = gql`
  query postalCodeLookup($countryName: String!, $postalCode: String!) {
    postalCodeLookup(countryName: $countryName, postalCode: $postalCode) {
      countryName
      postalCode
      city
      state
      source
      cached
      resolvedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PostalCodeLookupGQL extends Apollo.Query<
  PostalCodeLookupQuery,
  PostalCodeLookupQueryVariables
> {
  document = PostalCodeLookupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ProductDocument = gql`
  query product($slug: String!) {
    product(slug: $slug) {
      id
      slug
      name
      category {
        id
        slug
        name
        description
      }
      subcategory
      collection
      price
      originalPrice
      image
      shortDescription
      material
      rating
      reviewCount
      isNew
      isBestseller
      stockQuantity
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ProductGQL extends Apollo.Query<
  ProductQuery,
  ProductQueryVariables
> {
  document = ProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ProductsDocument = gql`
  query products($filter: ProductFilterInput) {
    products(filter: $filter) {
      id
      slug
      name
      category {
        slug
        name
        description
      }
      subcategory
      collection
      price
      originalPrice
      image
      shortDescription
      material
      rating
      reviewCount
      isNew
      isBestseller
      stockQuantity
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ProductsGQL extends Apollo.Query<
  ProductsQuery,
  ProductsQueryVariables
> {
  document = ProductsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateProductDocument = gql`
  mutation createProduct($input: ProductInput!) {
    createProduct(input: $input) {
      id
      slug
      name
      image
      stockQuantity
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateProductGQL extends Apollo.Mutation<
  CreateProductMutation,
  CreateProductMutationVariables
> {
  document = CreateProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateProductDocument = gql`
  mutation updateProduct($slug: String!, $input: ProductInput!) {
    updateProduct(slug: $slug, input: $input) {
      id
      slug
      name
      image
      stockQuantity
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateProductGQL extends Apollo.Mutation<
  UpdateProductMutation,
  UpdateProductMutationVariables
> {
  document = UpdateProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteProductDocument = gql`
  mutation deleteProduct($slug: String!) {
    deleteProduct(slug: $slug)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteProductGQL extends Apollo.Mutation<
  DeleteProductMutation,
  DeleteProductMutationVariables
> {
  document = DeleteProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VisibleCouponsDocument = gql`
  query visibleCoupons {
    visibleCoupons {
      id
      code
      description
      discountType
      discountValue
      minimumCartValue
      maximumDiscountAmount
      startsAt
      endsAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class VisibleCouponsGQL extends Apollo.Query<
  VisibleCouponsQuery,
  VisibleCouponsQueryVariables
> {
  document = VisibleCouponsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WishlistsDocument = gql`
  query wishlists {
    wishlists {
      id
      name
      isDefault
      items {
        id
        product {
          id
          slug
          name
          price
          originalPrice
          image
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class WishlistsGQL extends Apollo.Query<
  WishlistsQuery,
  WishlistsQueryVariables
> {
  document = WishlistsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
